<template>
  <section class="block block--light">
    <div class="home-block--light group group--first-last-small">
      <h3 class="h3 mt0">Root Canals</h3>
      <div
        class="root-canal-faq mt2"

        v-for="(faq, index) in faqs"
        :key="index"
      >
        <div class="root-canal-faq__content-wrap">
          <img class="root-canal-faq__green-check" :src="checkImage" alt="">
          <div class="faq-content">
            <h3 class="h3 mt0 fw-semibold">{{ faq.title }}</h3>
            <p class="p">{{ faq.body }}</p>
          </div>
        </div>
        <img class="root-canal-faq__illustration" :src="faq.image" alt="">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      checkImage: require(`images/icons/check-green.svg`),
      faqs: [
        {
          title: `Rubber Dam used?`,
          body: `A Rubber Dam is considered the standard of care and should ` +
          `be used in all instances.  It may be awkward, but this protects the ` +
          `area the doctor is working on and greatly reduces the potential for future infection.`,
          image: require(`images/rootCanalFaq/rubber-dam.png`),
        },
        {
          title: `Conservative access prep?`,
          body: `Has the dentist drilled the small hole needed, or a much bigger hole ` +
          `than is typically required? A bigger hole not only damages your tooth more, ` +
          `it also increases your risk of future problems.`,
          image: require(`images/rootCanalFaq/appropriate-access-prep.png`),
        },
        {
          title: `All canals cleaned and shaped?`,
          body: `Did you know there is not a standard number of canals for each tooth? ` +
          `So finding all the canals can be a challenge. Did the dentist treat each of the ` +
          `canals of your tooth or did he/she miss one.  Missing a canal can leave an opening ` +
          `for future infections and require another procedure in the future.`,
          image: require(`images/rootCanalFaq/all-canals-treated.png`),
        },
        {
          title: `Canals cleaned and shaped to the apex?`,
          body: `The filling should go to the tip of your root. Not filling enough (under-fill) ` +
          `can leave space for harmful bacteria to grow. A filling that goes beyond the root tip ` +
          `(over-fill) can cause damage to the bone, sinus, or even nerve damage in severe cases. `+
          `Over or under filling increases the chances that you'll need to have another procedure down the road.`,
          image: require(`images/rootCanalFaq/canals-cleaned2.png`),
        },
        {
          title: `Adequate root filling density?`,
          body: `The canals should be filled without leaving any spaces between the walls of the ` +
          `tooth. Spaces can leave room for bacteria and toxins that eventually cause an infection, `+
          `often requiring another root canal.`,
          image: require(`images/rootCanalFaq/adequate-root-filling-density.png`),
        },
        {
          title: `Signs of perforation?`,
          body: `Dentists are human and sometimes make mistakes. We’re simply looking to see if ` +
          `the dentist drilled out the side of your tooth. Yep, it happens.`,
          image: require(`images/rootCanalFaq/perforation1.png`),
        },
        {
          title: `Sign of separated instrument?  `,
          body: `Sometimes a dentist can break off a piece of the small drill bit or file in your tooth. ` +
          `These tools are very delicate and must be used with great care.  Ideally the dentist will get ` +
          `the broken piece out.  If it’s not possible to get it out, did the dentist at least tell you about this?`,
          image: require(`images/rootCanalFaq/signs-of-seperated-instrument.png`),
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// RootCanalFaq.vue?f5b09a9c